/**
 * @author Fernando Tapia <ftapia@pensare.mx>
 * @version 1.0.0
 * @file Method to get information about access control
 */

import {URL_SERVER} from '../../utils/constants.js';

export function getFetch(serviceURL, method, params) {
  var headers = new Headers();
  return fetch(URL_SERVER + serviceURL, {
    method: method,
    body: JSON.stringify(params),
    headers: new Headers({
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    })
  })
    .then(response => {
      if (response.status === 200) {
        sessionStorage.setItem('token', response.headers.get("Authorization"));
      }
      return response.status;
    });
}

export class DataUser {
  constructor(name, rol, businessUnit, idBusinessUnit, account) {
    this.name = name;
    this.rol = rol;
    this.businessUnit = businessUnit;
    this.idBusinessUnit = idBusinessUnit;
    this.account = account;
  }
}



// WEBPACK FOOTER //
// ./src/service/access-control/requestsAccess.js